import { FiltersBar } from "@/components/invoices/FiltersBar";
import { InvoiceTable } from "@/components/invoices/InvoiceTable";
import { PageSizeBar } from "@/components/invoices/PageSizeBar";
import { PaginationBar } from "@/components/invoices/PaginationBar";
import { PageHeader } from "@/components/PageHeader";
import { InvoicesProvider, useInvoices } from "@/contexts/InvoicesContext";
import * as shared from "@/styles/shared";
import type { InvoiceContentProps } from "@/types/ui";
import { FileText } from "lucide-react";
import { useTranslation } from "react-i18next";
import { styles } from "./InvoicesPage.styles";

const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

const InvoicesPage = () => {
  const { t } = useTranslation(["common", "invoices"]);

  return (
    <InvoicesProvider>
      <div className={styles.container}>
        {/* Header */}
        <PageHeader icon={FileText} title={t("pageTitle", { ns: "invoices" })} />

        <FiltersBar />
        <PageSizeBar pageSizeOptions={PAGE_SIZE_OPTIONS} />
        <InvoiceContent t={t} />
      </div>
    </InvoicesProvider>
  );
};

const InvoiceContent = ({ t }: InvoiceContentProps) => {
  const invoiceData = useInvoices();

  if (invoiceData.loading) {
    return (
      <div className={shared.formStack}>
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className={styles.loadingItem} />
        ))}
      </div>
    );
  }

  if (!invoiceData.invoices.length) {
    return (
      <div className={styles.emptyState}>
        <FileText className={`${styles.emptyIcon} ${styles.emptyIconWrapper}`} />
        <p className={styles.emptyText}>{t("noInvoicesFound", { ns: "invoices" })}</p>
        <p className={styles.emptyHint}>{t("noInvoicesHint", { ns: "invoices" })}</p>
      </div>
    );
  }

  return (
    <>
      <InvoiceTable invoices={invoiceData.invoices} />
      {invoiceData.totalPages > 1 && (
        <PaginationBar page={invoiceData.page} totalPages={invoiceData.totalPages} total={invoiceData.total} limit={invoiceData.limit} />
      )}
    </>
  );
};

export default InvoicesPage;
